import { ClipboardList, Handshake, KeyRound } from "lucide-react";

const STEPS = [
  {
    icon: ClipboardList,
    title: "1. Tell Us About Your Home",
    body: "Fill out our quick form with a few details about your property. No obligation, no spam.",
    testid: "step-1",
  },
  {
    icon: Handshake,
    title: "2. Get a Fair Cash Offer",
    body: "We review your property and present a clear, no-pressure cash offer — usually within 24 hours.",
    testid: "step-2",
  },
  {
    icon: KeyRound,
    title: "3. Close in 3 Weeks or Less",
    body: "Pick your closing date. We handle the paperwork, fees, and details. You walk away with cash.",
    testid: "step-3",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="bg-[#F1EDE7] py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.2em] text-[#D95D39] font-medium">
            How It Works
          </span>
          <h2 className="mt-3 font-[Outfit] font-semibold text-[#2C3D30] text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            Three simple steps. Zero stress.
          </h2>
          <p className="mt-4 text-[#5B6B5F] text-base lg:text-lg">
            We&apos;ve designed our process around speed, transparency, and respect for your time.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {STEPS.map((s, idx) => {
            const Icon = s.icon;
            return (
              <div
                key={s.testid}
                data-testid={s.testid}
                className="bg-white rounded-2xl p-8 border border-[#E2DDD7] shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_14px_40px_rgb(0,0,0,0.08)] transition-shadow tr-fade-up"
                style={{ animationDelay: `${idx * 120}ms` }}
              >
                <div className="w-14 h-14 rounded-2xl bg-[#F1EDE7] flex items-center justify-center text-[#D95D39] mb-6">
                  <Icon strokeWidth={1.5} className="w-7 h-7" />
                </div>
                <h3 className="font-[Outfit] font-medium text-[#2C3D30] text-xl tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-[#5B6B5F] text-sm leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
